import _ from 'lodash';

export function ifRole(userService) {
  'ngInject';

  return {
    link: link,
    priority: 500,
    restrict: 'A',
    scope: {
      ifRole: '=',
    },
  };

  function link(scope, element) {
    const roles = scope.ifRole;
    const hasRole = userService.hasRole(roles);

    if (hasRole) {
      const role = _.kebabCase(userService.get().role);
      element.parent().addClass(`role-${role}`);
      return;
    }
    element.remove();
  }
}

export function unlessRole(userService, $rootScope) {
  'ngInject';

  return {
    link: link,
    priority: 500,
    restrict: 'A',
    scope: {
      unlessRole: '=',
    },
  };

  function link(scope, element) {
    function checkRole() {
      const roles = scope.unlessRole;
      const hasRole = userService.hasRole(roles);
      if (hasRole) {
        const role = _.kebabCase(userService.get().role);
        element.parent().addClass(`role-${role}`);
        element.remove();
      }
    }

    const roleChange = scope.$watch(() => userService.get().role, checkRole);
    const stateChange = $rootScope.$on('$stateChangeSuccess', checkRole);

    scope.$on('$destroy', () => {
      roleChange();
      stateChange();
    });
  }
}

export function hasPermission(userService) {
  'ngInject';

  return {
    link: link,
    priority: 500,
    restrict: 'A',
    scope: {
      hasPermission: '=',
    },
  };

  function link(scope, element) {
    const user = userService.get();
    const userPermissions = user && user.permissions;
    const hasPermissions =
      scope.hasPermission &&
      _.every(scope.hasPermission, (p) => {
        return _.includes(userPermissions, p);
      });

    if (!hasPermissions) {
      element.remove();
    }
  }
}

export function somePermission(userService) {
  'ngInject';

  return {
    link: link,
    priority: 500,
    restrict: 'A',
    scope: {
      somePermission: '=',
    },
  };

  function link(scope, element) {
    const user = userService.get();
    const userPermissions = user && user.permissions;
    const hasPermissions =
      !scope.somePermission ||
      (scope.somePermission &&
        _.some(scope.somePermission, (p) => {
          return _.includes(userPermissions, p);
        }));

    if (!hasPermissions) {
      element.remove();
    }
  }
}
